/**
 * RFC 4122 v4 UUID. `crypto.randomUUID` exists only in secure contexts, so plain-http LAN testing
 * falls back to `crypto.getRandomValues`, which is available everywhere.
 */
export function randomUuid(c: Crypto = globalThis.crypto): string {
  if (typeof c.randomUUID === "function") return c.randomUUID();
  const b = c.getRandomValues(new Uint8Array(16));
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

/** Unguessable object name keeping a short safe extension (upstream used Math.random()). */
export function objectNameFor(
  fileName: string,
  uuid: string = randomUuid(),
): string {
  const dot = fileName.lastIndexOf(".");
  const ext = dot > 0 ? fileName.slice(dot + 1) : "";
  return /^[A-Za-z0-9]{1,10}$/.test(ext)
    ? `${uuid}.${ext.toLowerCase()}`
    : uuid;
}
